// extracted by mini-css-extract-plugin
export default {"refreshDataButton":"styles_refreshDataButton__joIzr","suppressZerosCheckbox":"styles_suppressZerosCheckbox__--Bxs"};